export default __webpack_public_path__ + "static/media/Snd4.c3f2de7c.mp3";